






























































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import UserResearchCenter from "@/models/security/userResearchCenter.Model";
import UserService from "@/services/user.service";
import TipoEvaluacion from "@/models/evaluacion/tipoEvaluacion.model";
import BaseSelectComponent from "@/components/base/baseSelect/baseSelect.vue";
import { ParesEvaluadoresTypes } from "@/enums/ParesEvaluadoresTypes";
@Component({
  components: {
    BaseSelectComponent
  }
})
export default class EvaluationTypeAdd extends GenericAdd<TipoEvaluacion> {
  active = false;
  researchCenters = [];
  userService: UserService = new UserService();
  loading: boolean = false;
  userSelected: any = null;
  /* 
  types = [
    {
      id: ParesEvaluadoresTypes.PERTINENCIA,
      name: 'Pertinencia'
    },
    {
      id: ParesEvaluadoresTypes.CIENTIFICOTECNICO,
      name: 'Científico Técnico'
    },
    {
      id: ParesEvaluadoresTypes.FINANCIERO,
      name: 'Financiero'
    },
  ];
  */

  constructor() {
    super();
    this.controller = "TipoEvaluacion";
    this.model = new TipoEvaluacion();
  }

  mounted() {}

  get user() {
    return this.$store.state.user;
  }
}
